import { render, staticRenderFns } from "./TotalScoreCircle.vue?vue&type=template&id=3a94c01d&scoped=true&"
import script from "./TotalScoreCircle.vue?vue&type=script&lang=js&"
export * from "./TotalScoreCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94c01d",
  null
  
)

export default component.exports